import React from 'react'

import { DifficultyTag } from '../Courses/DifficultyTag'

export const renderDifficultyTagCell = (level) => (
  <DifficultyTag difficulty={level} />
)
